"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const TsvSchemaComponent = (props) => {
    const { value, registerProps, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onChange = (e) => {
        const text = e.target.value;
        const lines = text.split("\n").map((line) => line.split("\t"));
        const header = lines.shift();
        if (!header)
            throw new Error();
        const allData = lines.map((line) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const lineData = {};
            line.forEach((item, index) => {
                if (item) {
                    const path = header[index];
                    const keys = path.split(".");
                    keys.reduce((prev, key, index) => {
                        if (index < keys.length - 1) {
                            if (!prev[key]) {
                                prev[key] = {};
                            }
                            return prev[key];
                        }
                        else {
                            prev[key] = item;
                            return item;
                        }
                    }, lineData);
                }
            });
            return lineData;
        });
        console.log({ lines, allData });
        registerProps.onChange(allData);
    };
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState },
        react_1.default.createElement(Form_1.default.Control, Object.assign({ as: "textarea", className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }), style: { height: "160px" }, defaultValue: "" }, registerProps, { onChange: onChange }))));
};
TsvSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("TsvDisplayComponent");
exports.default = TsvSchemaComponent;
